import { Users } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

export function MeetingNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-meeting"
      shape="dotted-card"
      accentColor={colors.graphite[600]}
      icon={Users}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      dashedBorder
      isConnectable={isConnectable}
    />
  );
}
